import styled from "styled-components";
import { rem } from "../../../Theme/Theme.constants.js";
import { DefaultAvatarProps } from "../../Avatar.types.js";
import { DotProps } from "./types.js";

export const dotSizeMap: Record<DefaultAvatarProps["size"], string> = {
    extraSmall: rem(0.25),
    small: rem(0.5),
    medium: rem(0.75),
    large: rem(1),
    extraLarge: rem(1.25),
};

export const cutOutRadiusMap: Record<DefaultAvatarProps["size"], string> = {
    extraSmall: rem(0.25),
    small: rem(0.375),
    medium: rem(0.5),
    large: rem(0.75),
    extraLarge: rem(1),
};

export const cutOutPositionMap: Record<DefaultAvatarProps["size"], string> = {
    extraSmall: rem(0.25),
    small: rem(0.25),
    medium: rem(0.5),
    large: rem(0.625),
    extraLarge: rem(0.75),
};

export const StyledStateDot = styled.div<DotProps & Pick<DefaultAvatarProps, "size">>`
    background-color: ${({ color, theme }) =>
        color === "white" || color === "neutral" ? theme.grayscale[70] : color in theme.colors ? theme.colors[color][100] : color};
    position: absolute;
    bottom: ${({ size, theme }) => (size === "small" ? 0 : size === "medium" ? theme.rem(0.125) : "2.5px")};
    right: ${({ size, theme }) => (size === "small" ? 0 : size === "medium" ? theme.rem(0.125) : "2.5px")};
    height: ${({ size }) => dotSizeMap[size]};
    width: ${({ size }) => dotSizeMap[size]};
    border: ${({ theme }) => theme.rem(0.125)} solid ${({ theme }) => theme.grayscale.white};
    border-radius: ${({ theme }) => theme.radius.round};
`;
